// src/config/index.js
import { PUBLIC_RUNTIME_CONFIG } from './publicRuntimeConfig';

const environmentMode = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
const isProduction = environmentMode === 'production';

console.log(`Environment mode: ${environmentMode}`);
console.log(`Using ${isProduction ? 'PRODUCTION' : 'TEST'} Stripe price IDs`);

const PRICE_IDS = {
  test: {
    sixMonth:
      process.env.REACT_APP_STRIPE_TEST_SIX_MONTH_PRICE_ID ||
      PUBLIC_RUNTIME_CONFIG.stripePriceIds.test.sixMonth,
    lifetime:
      process.env.REACT_APP_STRIPE_TEST_LIFETIME_PRICE_ID ||
      PUBLIC_RUNTIME_CONFIG.stripePriceIds.test.lifetime,
  },
  production: {
    sixMonth:
      process.env.REACT_APP_STRIPE_PROD_SIX_MONTH_PRICE_ID ||
      PUBLIC_RUNTIME_CONFIG.stripePriceIds.production.sixMonth,
    lifetime:
      process.env.REACT_APP_STRIPE_PROD_LIFETIME_PRICE_ID ||
      PUBLIC_RUNTIME_CONFIG.stripePriceIds.production.lifetime,
  },
};

const priceIds = isProduction ? PRICE_IDS.production : PRICE_IDS.test;

const CONFIG = {
  tiers: {
    free: {
      name: 'Free Plan',
      displayPrice: 0,
      stripePriceId: null,
      maxUploads: 1,
      maxRecordTime: 30,
      quality: 'SD',
    },
    sixMonth: {
      name: '6-Month Plan',
      displayPrice: 30,
      stripePriceId: priceIds.sixMonth,
      maxUploads: 30,
      maxRecordTime: 60,
      quality: 'SD',
    },
    lifetime: {
      name: 'Lifetime Access',
      displayPrice: 60,
      stripePriceId: priceIds.lifetime,
      maxUploads: 150,
      maxRecordTime: 300,
      quality: 'HD',
    },
  },
  recording: {
    defaultMimeType: 'video/webm; codecs=vp8,opus',
    fallbackMimeType: 'video/webm; codecs=vp9',
    iosMimeType: 'video/mp4',
    videoBitsPerSecond: 1500000,
    hdVideoBitsPerSecond: 3500000,
    mobileVideoBitsPerSecond: 800000,
    mobileHdVideoBitsPerSecond: 1500000,
    frameRate: { ideal: 30 },
    mobileFrameRate: { ideal: 24 },
    resolution: {
      sd: { width: 640, height: 576 },
      hd: { width: 1280, height: 720 },
      mobileSd: { width: 480, height: 360 },
      mobileHd: { width: 720, height: 480 },
    },
    countdownSeconds: 3,
    timerColors: {
      green: 'green',
      orange: 'orange',
      red: 'red',
    },
    warningThresholds: {
      orange: 0.8,
      red: 0.9,
    },
  },
  ui: {
    buttons: {
      getCameraReady: 'Get Camera Ready',
      startRecording: 'Start Recording',
      stopRecording: 'Stop Recording',
      saveVideo: 'Save Video',
    },
    labels: {
      videoTitle: 'Video Title:',
    },
    toasts: {
      cameraReady: 'Camera is ready!',
      recordingStopped: 'Recording stopped!',
      videoSaved: 'Video saved successfully!',
      userDataNotFound: 'User data not found. Please contact support.',
      failedToFetchUserData: 'Failed to fetch user data. Please try again.',
      couldNotAccessCamera: 'Could not access your camera. Please check permissions.',
      recordingFailed: 'Recorded video is empty. Please try recording again.',
      recordingStartFailed: 'Failed to start recording.',
      invalidSubscriptionTier: 'Invalid subscription tier. Please contact support.',
      uploadLimitReached: 'You have reached your video upload limit. Please upgrade your plan.',
      videoUploadFailed: 'Error uploading video. Please try again later.',
      thumbnailProcessingFailed: 'Error processing thumbnail.',
      thumbnailGenerationFailed: 'Failed to create thumbnail.',
      videoElementNotFound: 'Video element not found.',
      videoDeleteError: 'Failed to delete video:',
      videoDeleted: 'Video deleted successfully!',
      videoNotFound: 'Video not found.',
      fetchUserDataFailed: 'Failed to fetch user data.',
      noPermission: 'You do not have permission to perform this action.',
      mustBeSignedIn: 'You must be signed in to perform this action.',
      confirmDelete: 'Are you sure you want to delete this video?',
    },
  },
  features: {
    teleprompter: false,
  },
  errors: {
    cameraAccessDenied: 'Could not access your camera. Please check permissions.',
    recordingFailed: 'Failed to start recording. Please try again.',
    uploadFailed: 'Error uploading video. Please try again later.',
    videoElementNotFound: 'Video element not found.',
    thumbnailGenerationFailed: 'Failed to create thumbnail.',
    invalidSubscriptionTier: 'Invalid subscription tier.',
  },
};

export default CONFIG;
